export default "__VITE_ASSET__CIqz8SlK__"